import dayjsBase from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear.js';
import weekOfYear from 'dayjs/plugin/weekOfYear.js';
import utc from 'dayjs/plugin/utc.js';
let initialized = false;
export const dayjs = dayjsBase;
/**
 * Ensure Day.js has the needed plugins for presets and UTC normalization.
 * Idempotent: safe to call multiple times.
 */
export function setupDayjs() {
    if (initialized)
        return;
    dayjs.extend(utc);
    dayjs.extend(quarterOfYear);
    dayjs.extend(weekOfYear);
    initialized = true;
}
//# sourceMappingURL=dayjs-setup.js.map